import { useState, useEffect, useRef } from 'react'
import { FiCheckCircle, FiAlertCircle, FiX } from 'react-icons/fi'

import bus from '../../../utils/bus'

import './message.css'

const ICON_BY_TYPE = {
    success: FiCheckCircle,
    error: FiAlertCircle,
}

const DURATION = 8000

function Message() {
    const [visibility, setVisibility] = useState(false)
    const [message, setMessage] = useState('')
    const [type, setType] = useState('')
    const [instanceKey, setInstanceKey] = useState(0)
    const timeoutRef = useRef(null)

    useEffect(() => {

        const handleFlash = ({ message, type }) => {
            setVisibility(true)
            setMessage(message)
            setType(type)
            setInstanceKey((prev) => prev + 1)

            if (timeoutRef.current) clearTimeout(timeoutRef.current)
            timeoutRef.current = setTimeout(() => {
                setVisibility(false)
            }, DURATION)
        }

        // Mensagem deixada por um redirecionamento de página inteira (ex:
        // sessão expirada) — o bus não sobrevive ao reload, então relê daqui.
        const pending = sessionStorage.getItem('pendingFlash')
        if (pending) {
            sessionStorage.removeItem('pendingFlash')
            handleFlash(JSON.parse(pending))
        }

        bus.addListener('flash', handleFlash)
        return () => {
            bus.removeListener('flash', handleFlash)
            if (timeoutRef.current) clearTimeout(timeoutRef.current)
        }
    }, [])

    const Icon = ICON_BY_TYPE[type] || FiCheckCircle

    return (
        visibility && (
            <div className={`message ${type}`}>
                <div className="message-icon"><Icon size={19} /></div>
                <div className="message-text">{message}</div>
                <div onClick={() => { setVisibility(false) }} className="message-close"><FiX size={16} /></div>
                <div
                    key={instanceKey}
                    className="message-progress"
                    style={{ animationDuration: `${DURATION}ms` }}
                />
            </div>
        )
    )
}

export default Message
